@if (showAddAnnotation()) {
    <div class="supervisor-dialog-backdrop"></div>
    <dialog class="supervisor-dialog" open>
      <app-add-annotation
        [patientID]="patientIDAsNumber"
        [annotationToEdit]="selectedAnnotation"
        (close)="onCloseAddAnnotation($event)"
      />
    </dialog>
    }
<div class="container-fluid">
    @if(canManageAnnotations()) {
      <div class="row" id="supervisorAnnotationsButtons">
        <div class="d-flex flex-row gap-3 ms-3 me-3">
          <button
            (click)="addAnnotationButtonClicked()"
            class="side-menu-button2 w-100"
            id="addAnnotationButton"
          >
            + Annotation
          </button>
        </div>
      </div>
    }
  
    <p-table
      [value]="filteredAnnotations()"
      #dt
      id="annotations"
      dataKey="ID"
      [tableStyle]="{ width: '100%' }"
      [loading]="isLoading"
      [rows]="25"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="true"
      [responsive]="true"
      [resizableColumns]="true"
      styleClass="p-datatable-sm"
      [scrollable]="true"
      [scrollHeight]="'flex'"
    >
      <ng-template pTemplate="caption">
        <div class="container text-center" id="annotationsCaption">
          <div class="row mb-3 justify-content-center">
            <div class="col-12">
              <span class="p-input-icon-left w-100">
                <i class="pi pi-search"></i>
                <input
                  pInputText
                  type="text"
                  class="w-100"
                  placeholder="Annotation Label"
                  id="searchBarInput"
                  [(ngModel)]="searchKeyword"
                />
              </span>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12">
              <div class="d-flex flex-wrap gap-3" id="annotationsFiltersButtons">
                <p-multiSelect
                  appendTo="body"
                  [group]="true"
                  [options]="possibleFilters()"
                  name="selectedFilters"
                  [(ngModel)]="selectedFilters"
                  display="chip"
                  [showClear]="true"
                  placeholder="Select Filters"
                  [style]="{ width: '100%' }"
                >
                </p-multiSelect>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12">
              <div class="d-flex flex-wrap gap-3 justify-content-end">
                @if(!includeDeleted()) {
                <p-button
                  [style]="{
                    color: 'red',
                    backgroundColor: 'white',
                    border: '2px solid red',
                    'border-radius': '10px'
                  }"
                  label="Include Deleted"
                  icon="pi pi-trash"
                  (onClick)="toggleIncludeDeleted()"
                />
                } @else {
                <p-button
                  [style]="{
                    color: 'white',
                    backgroundColor: 'red',
                    border: '2px solid white',
                    'border-radius': '10px'
                  }"
                  label="Exclude Deleted"
                  icon="pi pi-trash"
                  (onClick)="toggleIncludeDeleted()"
                />
                }

                <p-button
                  label="Clear"
                  [style]="{
                    'border-radius': '10px',
                    border: '2px solid #719eb6'
                  }"
                  icon="pi pi-filter-slash"
                  (click)="clearSearch()"
                />
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="body" let-annotation>
        <app-annotation
          [annotation]="annotation"
          [targets]="targets()"
          [behaviors]="behaviors()"
          [programs]="programs()"
          [skillAreas]="skillAreas()"
          (onEditAnnotationClicked)="onEditAnnotationClicked($event)"
          [canManageAnnotations]="canManageAnnotations()"
          (onDeleteAnnotation)="onDeleteAnnotation()"
        ></app-annotation>
      </ng-template>
  
      <ng-template pTemplate="emptymessage">
        <p
          style="
            text-align: center;
            margin-top: 20px;
            font-size: 1rem;
            color: #719eb6;
          "
        >
          There are no Annotations yet.
        </p>
      </ng-template>
    </p-table>
  </div>
  
